<template>
  <div>
    <h1>Sign Up Start</h1>

    <KadoMenu />

    <table class="table-signupstart">
      <tr>
        <td>
          Mail Address:
        </td>
        <td>
          <div class="div-signupstart-inputText">
            <input class="inputText-common" type="email" placeholder="Mail Address" v-model="email" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Username:
        </td>
        <td>
          <div class="div-signupstart-inputText">
            <input class="inputText-common" type="text" placeholder="Username" v-model="username" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Password:
        <td>
          <div class="div-signupstart-inputText">
            <input class="inputText-common" type="password" placeholder="Password" v-model="password" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Password(confirm):
        </td>
        <td>
          <div class="div-signupstart-inputText">
            <input class="inputText-common" type="password" placeholder="Password(confirm)" v-model="passwordConfirm" required />
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="div-signupstart-button" >
            <button class="button-normal button-normal__extra" @click="singUpStart">Sign Up</button>
          </div>
        </td>
      </tr>
    </table>
    <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'SignUpStart',

  components: {
    KadoMenu
  },

  data () {
    return {
      username: '',
      email: '',
      password: '',
      passwordConfirm: '',
      procMsgNormal: null,
      procMsgAttention: null
    }
  },

  methods: {

    /* =================================================================================
     * signUpStart
     *   サインアップを開始
     * ============================================================================== */
    singUpStart () {
      mc.LOG_LEVEL ? console.log('%c info: method=signUpStart: Start', mc.LOG_TYPE_I) : (() => {})()
      this.resetProcMsg()
      if (this.email && this.username && (this.password === this.passwordConfirm)) {
        const myAuth = new MyAuth()
        myAuth.signUpStart(this.email, this.username, this.password)
          .then(resutl => {
            mc.LOG_LEVEL ? console.log('%c info: call=myAuth.signUpStart: OK', mc.LOG_TYPE_I) : (() => {})()
            this.WriteProcMsg('normal', 'Fisrt step of sign up has been done, next, fix sign up process.')
            setTimeout(() => { this.$router.push('/auth/signupfix') }, mc.MSG_TIMEOUT)
          })
          .catch(err => {
            mc.LOG_LEVEL ? console.log('%c error: call=myAuth.signUpStart: err:', mc.LOG_TYPE_E, err) : (() => {})()
            this.WriteProcMsg('attention', JSON.stringify(err))
          })
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  }
}
</script>

<style scoped>
.table-signupstart {
  margin-left: auto;
  margin-right: auto;
}
.div-signupstart-inputText {
  width: 15em;
  margin: 0 0.2em 0.2em 0.2em;
}
.div-signupstart-button {
  padding-top: 1em;
  text-align: center;
}
.button-normal__extra {
  width: 10em;
}
</style>
